<template>
    <div class="d-flex">
        <div :class="['audio-player', secondaryStyle ? 'secondary' : 'primary']">
            <button @click="togglePlay" class="play-pause-button">
                <b-icon-pause-fill class="icon" v-if="isPlaying"></b-icon-pause-fill>
                <b-icon-play-fill class="icon" v-else></b-icon-play-fill>
            </button>
            <input type="range" class="audio-bar" v-model="progress" @input="seekAudio" max="100" />
            <span>{{ currentTime | formatTime }}</span>
        </div>
        
        <audio ref="audio" preload="auto" @timeupdate="updateProgress" @loadedmetadata="setDuration">
            <source :src="src" type="audio/mpeg" />
        </audio>
    </div>
</template>
  

<script>
export default {
    data () {
        return {
            isPlaying: false,
            currentTime: 0,
            progress: 0
        }
    },
    props: {
        secondaryStyle: {
            type: Boolean,
            default: false
        },
        src: {
            type: String
        }
    },
    watch: {
        'progress' (value) {
            if (value === 100) {
                this.progress = 0
                this.$refs.audio.currentTime = 0
                this.togglePlay()
            }
        }
    },
    methods: {
        togglePlay () {
            const audio = this.$refs.audio
            this.isPlaying ? audio.pause() : audio.play()
            this.isPlaying = !this.isPlaying
        },
        updateProgress () {
            const audio = this.$refs.audio
            this.currentTime = audio.currentTime
            this.progress = (audio.currentTime / audio.duration) * 100
        },
        seekAudio () {
            const audio = this.$refs.audio
            audio.currentTime = (this.progress / 100) * audio.duration
        },
        setDuration () {
            const audio = this.$refs.audio
            this.currentTime = audio.currentTime
        }
    },
    filters: {
        formatTime (time) {
            const minutes = Math.floor(time / 60)
            const seconds = Math.floor(time % 60).toString().padStart(2, '0')
            return `${minutes}:${seconds}`
        }
    }
}
</script>
  
<style lang="scss" scoped>
.audio-player {
  display: flex;
  align-items: center;
  padding: 10px;
  border-radius: 23px;
}

.primary {
    background-color: $blue;

    .play-pause-button {
        background-color: $blue;
        color: $secondary;
    }

    input[type="range"] {
        color: $secondary;
    }

    span {
        color: $secondary;
    }
}

.secondary {
    background-color: $secondary;

    .play-pause-button {
        background-color: $secondary;
        color: $blue;
    }
    
    input[type="range"] {
        color: $blue;
    }

    span {
        color: $blue;
    }
}

.play-pause-button {
  border: none;
  display: flex;
}

input[type="range"] {
  margin: 0 10px;
  flex-grow: 1;
  height: 5px;
  border-radius: 5px;
  background-color: $white;
}

span {
  font-size: 0.9rem;
}

.icon {
  height: 1.3rem;
  width: 2rem;
}

</style>


// WEBPACK FOOTER //
// src/components/utils/AudioPlayer.vue